import { LearningObjectTypes } from '@hendrx/lms/constants';
import { useContext } from 'react';

import { WidgetComponentContext } from './WidgetComponentContext';
import { useWorkMode } from './useWorkMode';
import { WidgetType } from '../common/utils/widgetsUtils';
import { useLearningObjectCommonData } from '../components/providers/LearningObjectCommonDataProvider';
import { useUser } from '../queries/user';

export const useWidgetComponent = (widgetType: WidgetType) => {
  const widgetComponentContext = useContext(WidgetComponentContext);
  if (widgetComponentContext === null) throw new Error('WidgetComponentContext not initialized properly.');

  const { getWidget } = widgetComponentContext;

  const { isStudioEdit } = useWorkMode();
  const { user } = useUser();
  const { learningObjectType } = useLearningObjectCommonData();

  const isPlenaryLesson = learningObjectType === LearningObjectTypes.PlenaryLesson;
  const isPlenaryLessonStudent = isPlenaryLesson && user?.role === 'plenaryStudent';

  return getWidget(widgetType, isStudioEdit, isPlenaryLessonStudent);
};
